import serialize from 'serialize-javascript';

export function encode(data: any): string {
  return serialize(data, {isJSON: true});
}

export function decode(string: string): any {
  return JSON.parse(string);
}
